const ODYSSEE_CONSTELLATIONS = {
  cassiopeia: {
    stars: [
      [-32.2, 4.7, 2.3],
      [-10.6, 19.0, 2.2],
      [0.5, -4.0, 2.2],
      [20.5, -1.3, 2.7],
      [40.2, -20.2, 3.4],
    ],
    lines: [[0, 1], [1, 2], [2, 3], [3, 4]],
  },
  ursa_minor: {
    stars: [
      [0, -40, 2.0],
      [8, -22, 4.3],
      [6, -6, 4.2],
      [0, 10, 4.3],
      [14, 18, 5.0],
      [32, 12, 2.1],
      [26, 28, 3.0],
    ],
    lines: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 6], [6, 5], [5, 3]],
  },
  ursa_major: {
    stars: [
      [-38.6, -18.4, 1.8],
      [-39.4, -1.2, 2.4],
      [-16.2, 7.4, 2.4],
      [-6.5, -3.3, 3.3],
      [10.8, 0.1, 1.8],
      [24.1, 3.4, 2.3],
      [34.7, 21.4, 1.9],
    ],
    lines: [[0, 1], [1, 2], [2, 3], [3, 0], [3, 4], [4, 5], [5, 6]],
  },
  cygnus: {
    stars: [
      [19.0, -27.7, 1.3],
      [4.7, -8.6, 2.2],
      [-33.9, 38.2, 3.1],
      [22.6, 15.3, 2.5],
      [-23.3, -27.1, 2.9],
    ],
    lines: [[0, 1], [1, 2], [3, 1], [1, 4]],
  },
  pegasus: {
    stars: [
      [22, -22, 2.1],
      [-22, -20, 2.4],
      [-22, 22, 2.5],
      [22, 22, 2.8],
      [-36, 8, 3.4],
      [-48, 2, 2.4],
    ],
    lines: [[0, 1], [1, 2], [2, 3], [3, 0], [1, 4], [4, 5]],
  },
  andromeda: {
    stars: [
      [-38.6, 20.7, 2.1],
      [-23.3, 15.4, 3.3],
      [-1.4, 1.1, 2.1],
      [-8.9, -7.5, 3.9],
      [8.4, -16.2, 3.8],
      [31.5, -19.0, 2.2],
    ],
    lines: [[0, 1], [1, 2], [2, 5], [2, 3], [3, 4]],
  },
  leo: {
    stars: [
      [-19.6, 15.7, 1.4],
      [-20.2, 3.2, 3.5],
      [-12.4, -4.8, 2.0],
      [-14.4, -14.1, 3.4],
      [-29.2, -20.8, 3.9],
      [-33.5, -15.0, 3.0],
      [42.7, 8.9, 2.1],
      [21.1, -6.6, 2.6],
      [21.2, 6.7, 3.3],
    ],
    lines: [[5, 4], [4, 3], [3, 2], [2, 1], [1, 0], [0, 8], [8, 6], [6, 7], [7, 2]],
  },
  bootes: {
    stars: [
      [-15.8, 32.5, 0.2],
      [3.2, 8.8, 2.4],
      [-5.9, -1.1, 3.6],
      [-5.1, -24.9, 3.0],
      [14.3, -31.2, 3.5],
      [23.0, -9.9, 3.5],
    ],
    lines: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 1]],
  },
  gemini: {
    stars: [
      [22.4, -25.2, 1.6],
      [30.2, -12.9, 1.1],
      [-19.2, 24.3, 1.9],
      [11.8, 6.5, 3.5],
      [-14.7, -3.6, 3.0],
      [-30.0, 4.8, 2.9],
      [-35.9, 24.3, 3.3],
      [0.1, 11.0, 3.8],
    ],
    lines: [[0, 1], [0, 4], [4, 5], [5, 6], [1, 3], [3, 7], [7, 2]],
  },
  lyra: {
    stars: [
      [0, -28, 0.0],
      [-14, 4, 3.5],
      [12, 2, 4.3],
      [-10, 22, 3.2],
      [16, 20, 3.2],
    ],
    lines: [[0, 1], [0, 2], [1, 2], [1, 3], [2, 4], [3, 4]],
  },
  canis_major: {
    stars: [
      [-6, -28, -1.5],
      [-28, -18, 2.0],
      [10, 2, 1.8],
      [-4, 16, 1.5],
      [22, 20, 2.4],
      [-22, 18, 3.0],
    ],
    lines: [[1, 0], [0, 2], [2, 3], [3, 4], [3, 5], [5, 1]],
  },
};

const RING_SHAPES = [
  'cassiopeia',
  'ursa_minor',
  'cygnus',
  'pegasus',
  'andromeda',
  'leo',
  'bootes',
  'gemini',
  'ursa_major',
];

const LEGACY_SHAPES = {
  lucida: 'ursa_minor',
  celeste: 'cygnus',
  vega: 'pegasus',
  ester: 'andromeda',
  sohalla: 'leo',
  astreos: 'bootes',
  asteria: 'gemini',
  sirius: 'ursa_major',
};

const NATURAL_SLOTS = [
  [0.50, 0.20],
  [0.74, 0.16],
  [0.88, 0.43],
  [0.69, 0.61],
  [0.46, 0.85],
  [0.20, 0.76],
  [0.12, 0.47],
  [0.22, 0.21],
  [0.37, 0.38],
];

function seedFieldStars(count = 38) {
  let seed = 1337;
  const rand = () => {
    seed = (seed * 16807) % 2147483647;
    return (seed - 1) / 2147483646;
  };

  const stars = [];
  for (let index = 0; index < count; index += 1) {
    const bright = rand() > 0.86;
    stars.push([
      rand(),
      rand(),
      bright ? 0.48 + rand() * 0.16 : 0.24 + rand() * 0.16,
      bright ? 0.38 + rand() * 0.1 : 0.22 + rand() * 0.12,
    ]);
  }
  return stars;
}

const FIELD_STARS = seedFieldStars();

class OdysseeCarteCeleste extends HTMLElement {
  constructor() {
    super();
    this.sky = null;
    this.chart = null;
    this.field = null;
    this.drawings = null;
    this.card = null;
    this.stars = [];
    this.layouts = [];
    this.viewW = 200;
    this.viewH = 130;
    this.activeIndex = -1;
    this.cardOpen = false;
    this.idleIndex = -1;
    this.idleTimer = null;
    this.pointerInside = false;
    this.pointerX = 0;
    this.pointerY = 0;
    this.rafId = null;
    this.leaveTimer = null;
    this.resizeTimer = null;
    this.isTouch = false;

    this.onPointerMove = this.handlePointerMove.bind(this);
    this.onPointerLeave = this.handlePointerLeave.bind(this);
    this.onResize = this.handleResize.bind(this);
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.sky = this.querySelector('[data-sky]');
    this.chart = this.querySelector('[data-chart]');
    this.field = this.querySelector('[data-field]');
    this.drawings = this.querySelector('[data-drawings]');
    this.card = this.querySelector('[data-card]');
    this.stars = [...this.querySelectorAll('[data-star]')];

    if (!this.sky || this.stars.length < 1) return;

    requestAnimationFrame(() => this.layoutAndDraw());

    this.stars.forEach((star, index) => {
      star.addEventListener('click', () => this.activate(index, true));
      star.addEventListener('focus', () => this.activate(index, true));
    });

    this.sky.addEventListener('pointermove', this.onPointerMove);
    this.sky.addEventListener('pointerleave', this.onPointerLeave);
    this.sky.addEventListener('pointerdown', (event) => {
      this.isTouch = event.pointerType === 'touch';
    });
    if (this.card) {
      const close = this.card.querySelector('[data-card-close]');
      if (close) close.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.closeCard();
      });
    }
    this.onKeyDown = (event) => {
      if (event.key === 'Escape' && this.cardOpen !== false) this.closeCard();
    };
    document.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('resize', this.onResize);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', this.onResize);
    if (typeof ResizeObserver === 'function') {
      this.resizeObserver = new ResizeObserver(() => this.onResize());
      this.resizeObserver.observe(this.sky);
    }
  }

  disconnectedCallback() {
    if (this.sky) {
      this.sky.removeEventListener('pointermove', this.onPointerMove);
      this.sky.removeEventListener('pointerleave', this.onPointerLeave);
    }
    window.removeEventListener('resize', this.onResize);
    if (this.onKeyDown) document.removeEventListener('keydown', this.onKeyDown);
    if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.onResize);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.rafId) cancelAnimationFrame(this.rafId);
    if (this.leaveTimer) clearTimeout(this.leaveTimer);
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    this.stopIdle(true);
  }

  handlePointerMove(event) {
    if (event.pointerType === 'touch') return;
    this.pointerX = event.clientX;
    this.pointerY = event.clientY;
    if (this.rafId != null) return;
    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      this.trackPointer();
    });
  }

  handlePointerLeave(event) {
    if (this.cardOpen !== false) return;
    if (event && this.card && (this.card === event.relatedTarget || this.card.contains(event.relatedTarget))) {
      return;
    }
    this.stars.forEach((star) => star.classList.remove('is-near'));
    if (this.leaveTimer) clearTimeout(this.leaveTimer);
    this.leaveTimer = window.setTimeout(() => {
      this.pointerInside = false;
      this.isTouch = false;
      this.deactivate();
    }, 420);
  }

  handleResize() {
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(() => {
      this.layoutAndDraw();
      if (this.activeIndex >= 0) this.syncDrawingState();
    }, 80);
  }

  trackPointer() {
    if (this.cardOpen !== false) return;

    const nearest = this.nearestConstellation(this.pointerX, this.pointerY);
    if (!nearest) return;

    const reach = Math.max(64, this.constellationSpan(this.viewW, this.viewH) * 0.62);
    if (nearest.distance < reach * 0.82) {
      this.highlight(nearest.index);
    } else {
      this.highlight(-1);
    }
  }

  nearestConstellation(clientX, clientY) {
    const sky = this.sky.getBoundingClientRect();
    if (!sky.width || !sky.height) return null;

    let best = null;
    this.layouts.forEach((layout, index) => {
      const x = sky.left + (layout.cx / this.viewW) * sky.width;
      const y = sky.top + (layout.cy / this.viewH) * sky.height;
      const distance = Math.hypot(clientX - x, clientY - y);
      if (!best || distance < best.distance) best = { index, distance, x, y };
    });
    return best;
  }

  highlight(index) {
    if (this.leaveTimer) {
      clearTimeout(this.leaveTimer);
      this.leaveTimer = null;
    }

    this.activeIndex = index;
    this.stars.forEach((node, i) => {
      const on = i === index;
      node.classList.toggle('is-near', on);
      node.classList.toggle('is-active', on);
    });
    this.syncDrawingState();

    if (index >= 0 || this.cardOpen !== false) this.stopIdle(true);
    else this.startIdle();
  }

  activate(index, locked = false) {
    const star = this.stars[index];
    if (!star) return;

    this.highlight(index);
    if (!locked) return;

    this.isTouch = true;
    this.cardOpen = index;
    this.classList.add('is-active');
    this.updateCard(star, index);
  }

  hideCard() {
    this.cardOpen = false;
    this.classList.remove('is-active');
    if (this.card) {
      this.card.classList.remove('is-visible');
      this.card.hidden = true;
    }
  }

  closeCard() {
    this.hideCard();
    this.highlight(-1);
    this.startIdle();
  }

  deactivate() {
    if (this.cardOpen !== false) return;
    this.highlight(-1);
    this.startIdle();
  }

  prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  idleDuration(index) {
    const own = Number(this.stars[index]?.dataset.idleInterval);
    const base = Number(this.dataset.idleInterval) || 2200;
    return own > 0 ? own : base;
  }

  pickIdleIndex() {
    const total = this.stars.length;
    if (total < 1) return -1;
    if (total === 1) return 0;
    let next = Math.floor(Math.random() * total);
    if (next === this.idleIndex) next = (next + 1 + Math.floor(Math.random() * (total - 1))) % total;
    return next;
  }

  startIdle() {
    if (this.cardOpen !== false || this.activeIndex >= 0 || this.prefersReducedMotion()) return;
    if (this.idleTimer != null) return;
    this.scheduleIdle();
  }

  scheduleIdle() {
    if (this.cardOpen !== false || this.activeIndex >= 0 || this.prefersReducedMotion()) return;
    const next = this.pickIdleIndex();
    if (next < 0) return;
    this.idleIndex = next;
    this.syncDrawingState();
    this.idleTimer = window.setTimeout(() => {
      this.idleTimer = null;
      this.scheduleIdle();
    }, this.idleDuration(next));
  }

  stopIdle(clearLit = false) {
    if (this.idleTimer != null) {
      clearTimeout(this.idleTimer);
      this.idleTimer = null;
    }
    if (clearLit) this.idleIndex = -1;
    this.syncDrawingState();
  }

  shapeKey(star, index) {
    const raw = (star.dataset.shape || 'auto').toLowerCase();
    if (raw === 'auto' || raw === '') return RING_SHAPES[index % RING_SHAPES.length];
    if (ODYSSEE_CONSTELLATIONS[raw]) return raw;
    return LEGACY_SHAPES[raw] || RING_SHAPES[index % RING_SHAPES.length];
  }

  normalizeStars(stars, targetSpan) {
    const cx = stars.reduce((sum, star) => sum + star[0], 0) / stars.length;
    const cy = stars.reduce((sum, star) => sum + star[1], 0) / stars.length;
    const xs = stars.map((star) => star[0] - cx);
    const ys = stars.map((star) => star[1] - cy);
    const span = Math.max(Math.max(...xs) - Math.min(...xs), Math.max(...ys) - Math.min(...ys), 1);
    const scale = targetSpan / span;
    return stars.map(([x, y, mag]) => [(x - cx) * scale, (y - cy) * scale, mag]);
  }

  measureSky() {
    const box = this.sky.getBoundingClientRect();
    return { w: box.width, h: box.height };
  }

  isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  constellationSpan(w, h) {
    if (this.isMobile()) return Math.min(w / 4.5, h / 5.1);
    return Math.min(w / 6.1, h / 4.1);
  }

  rawSlots(count) {
    if (count === NATURAL_SLOTS.length) return NATURAL_SLOTS.map((slot) => slot.slice());

    const slots = [];
    const start = -Math.PI / 2;
    for (let index = 0; index < count; index += 1) {
      const wobble = ((index * 37) % 9) - 4;
      const angle = start + (index * 2 * Math.PI) / count + wobble * 0.05;
      const radius = 0.34 + ((index % 3) - 1) * 0.07;
      slots.push([0.5 + Math.cos(angle) * radius, 0.5 + Math.sin(angle) * (radius * 0.9)]);
    }
    return slots;
  }

  fitSlots(slots, padX, padY) {
    const xs = slots.map((slot) => slot[0]);
    const ys = slots.map((slot) => slot[1]);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const spanX = maxX - minX || 1;
    const spanY = maxY - minY || 1;
    return slots.map(([x, y]) => [
      padX + ((x - minX) / spanX) * (1 - 2 * padX),
      padY + ((y - minY) / spanY) * (1 - 2 * padY),
    ]);
  }

  syncViewBox(w, h) {
    this.viewW = w;
    this.viewH = h;
    if (this.chart) this.chart.setAttribute('viewBox', `0 0 ${w} ${h}`);
  }

  usesCustomPositions() {
    const positions = this.stars.map((star) => [Number(star.dataset.posX), Number(star.dataset.posY)]);
    const usable = positions.filter(([x, y]) => Number.isFinite(x) && Number.isFinite(y));
    if (usable.length !== this.stars.length) return false;
    return !usable.every(([x, y]) => x === 50 && y === 50);
  }

  starCenter(star, index, fallbacks) {
    const x = Number(star.dataset.posX);
    const y = Number(star.dataset.posY);
    if (this.usesCustomPositions() && Number.isFinite(x) && Number.isFinite(y)) {
      return [this.viewW * (Math.min(100, Math.max(0, x)) / 100), this.viewH * (Math.min(100, Math.max(0, y)) / 100)];
    }
    const fallback = fallbacks[index] || [0.5, 0.5];
    return [fallback[0] * this.viewW, fallback[1] * this.viewH];
  }

  slotCenters(count, span) {
    const padX = Math.min(0.16, (span * 0.56) / this.viewW + 0.035);
    const padY = Math.min(0.16, (span * 0.56) / this.viewH + 0.045);
    const fallbacks = this.fitSlots(this.rawSlots(count), padX, padY);
    return this.stars.map((star, index) => this.starCenter(star, index, fallbacks));
  }

  layoutAndDraw() {
    if (!this.drawings) return;

    const { w, h } = this.measureSky();
    if (w < 50 || h < 50) return;
    if (
      this.layouts.length === this.stars.length &&
      Math.abs(w - this.viewW) < 6 &&
      Math.abs(h - this.viewH) < 6
    ) {
      this.positionHits();
      if (this.activeIndex < 0) this.startIdle();
      return;
    }

    this.syncViewBox(w, h);
    this.drawField();

    const count = this.stars.length;
    const targetSpan = this.constellationSpan(w, h);
    const centers = this.slotCenters(count, targetSpan);
    const midX = this.viewW * 0.5;
    const midY = this.viewH * 0.5;

    this.layouts = this.stars.map((star, index) => {
      const key = this.shapeKey(star, index);
      const catalog = ODYSSEE_CONSTELLATIONS[key] || ODYSSEE_CONSTELLATIONS.cassiopeia;
      const [cx, cy] = centers[index];
      const local = this.normalizeStars(catalog.stars, targetSpan);
      const points = local.map(([x, y, mag]) => [cx + x, cy + y, mag]);
      return {
        key,
        cx,
        cy,
        angle: Math.atan2(cy - midY, cx - midX),
        points,
        lines: catalog.lines,
        title: star.dataset.title || '',
      };
    });

    this.drawings.innerHTML = this.layouts
      .map((layout, index) => this.constellationMarkup(layout, index))
      .join('');

    this.drawings.querySelectorAll('[data-constellation]').forEach((group) => {
      const index = Number(group.getAttribute('data-index'));
      group.addEventListener('click', () => this.activate(index, true));
    });

    this.positionHits();
    this.syncDrawingState();
    if (this.activeIndex < 0) this.startIdle();
  }

  constellationMarkup(layout, index) {
    const d = layout.lines
      .map((pair) => {
        const a = layout.points[pair[0]];
        const b = layout.points[pair[1]];
        if (!a || !b) return '';
        return `M${a[0].toFixed(2)} ${a[1].toFixed(2)} L${b[0].toFixed(2)} ${b[1].toFixed(2)}`;
      })
      .join(' ');

    const nodes = layout.points
      .map(([x, y, mag]) => {
        const radius = this.starRadius(mag);
        return `<circle class="odyssee-carte__node" cx="${x.toFixed(2)}" cy="${y.toFixed(2)}" r="${radius.toFixed(2)}"></circle>`;
      })
      .join('');

    const labelR = this.constellationSpan(this.viewW, this.viewH) * 0.58;
    const title = this.escape(layout.title);
    const fontSize = this.isMobile() ? 11 : 15;
    const labelHalf = Math.ceil(String(layout.title || '').length * fontSize * 0.5);
    const lx = Math.min(
      this.viewW - labelHalf - 8,
      Math.max(labelHalf + 8, layout.cx + Math.cos(layout.angle) * labelR)
    );
    const ly = Math.min(this.viewH - 16, Math.max(18, layout.cy + Math.sin(layout.angle) * labelR + 4));
    const hitR = this.constellationSpan(this.viewW, this.viewH) * 0.52;

    return `
      <g class="odyssee-carte__constellation" data-constellation data-index="${index}">
        <circle class="odyssee-carte__hit-area" cx="${layout.cx.toFixed(2)}" cy="${layout.cy.toFixed(2)}" r="${hitR.toFixed(2)}"></circle>
        <path class="odyssee-carte__path" d="${d}" fill="none"></path>
        ${nodes}
        <text class="odyssee-carte__label" x="${lx.toFixed(2)}" y="${ly.toFixed(2)}" font-size="${fontSize}">${title}</text>
      </g>
    `;
  }

  starRadius(mag) {
    const mobile = this.isMobile();
    const value = (mobile ? 2.7 : 4.4) - Number(mag) * (mobile ? 0.28 : 0.42);
    return Math.min(mobile ? 3.4 : 5.4, Math.max(mobile ? 1.5 : 2.2, value));
  }

  positionHits() {
    this.stars.forEach((star, index) => {
      const layout = this.layouts[index];
      if (!layout) return;
      star.style.left = `${(layout.cx / this.viewW) * 100}%`;
      star.style.top = `${(layout.cy / this.viewH) * 100}%`;
    });
  }

  syncDrawingState() {
    if (!this.drawings) return;
    this.drawings.querySelectorAll('[data-constellation]').forEach((group) => {
      const index = Number(group.getAttribute('data-index'));
      const hovered = index === this.activeIndex || index === this.cardOpen;
      group.classList.toggle('is-active', hovered);
      group.classList.toggle('is-near', hovered);
      group.classList.toggle(
        'is-idle-lit',
        this.idleIndex === index && !hovered
      );
    });
  }

  drawField() {
    if (!this.field) return;
    const scale = Math.min(this.viewW, this.viewH) / 420;
    this.field.innerHTML = FIELD_STARS.map(([nx, ny, size, opacity]) => {
      const x = nx * this.viewW;
      const y = ny * this.viewH;
      const radius = Math.max(0.8, size * scale);
      return `<circle class="odyssee-carte__dust-star" cx="${x.toFixed(2)}" cy="${y.toFixed(2)}" r="${radius.toFixed(2)}" style="opacity:${opacity.toFixed(2)}"></circle>`;
    }).join('');
  }

  updateCard(star, index) {
    if (!this.card) return;
    const title = star.dataset.title || '';
    const total = String(this.stars.length).padStart(2, '0');
    const current = String(index + 1).padStart(2, '0');
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const src = (mobile ? star.dataset.imageMobile : star.dataset.imageDesktop) || star.dataset.imageMobile || '';
    const image = this.card.querySelector('[data-card-image]');
    const titleEl = this.card.querySelector('[data-card-title]');
    const counterEl = this.card.querySelector('[data-card-counter]');
    const linkEl = this.card.querySelector('[data-card-link]');

    if (titleEl) titleEl.textContent = title;
    if (counterEl) counterEl.textContent = `${current} / ${total}`;
    if (linkEl) {
      const href = star.dataset.link || linkEl.getAttribute('href') || '#';
      linkEl.setAttribute('href', href);
    }
    if (image) {
      image.alt = star.dataset.alt || title;
      if (src && image.getAttribute('src') !== src) image.src = src;
    }

    this.card.hidden = false;
    this.card.style.left = '';
    this.card.style.top = '';
    this.card.style.right = '';
    this.card.style.bottom = '';
    this.card.classList.remove('is-below');
    requestAnimationFrame(() => {
      this.card.classList.add('is-visible');
    });
  }

  escape(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}

if (!customElements.get('odyssee-carte-celeste')) {
  customElements.define('odyssee-carte-celeste', OdysseeCarteCeleste);
}
